import { Card } from 'react-bootstrap';
import LOGO from './../assets/images/vyapar_live_main_logo.png';
import { PiArrowLeftBold } from "react-icons/pi";
import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ApisService } from '../app/core/apis.service';
import { dataDecrypt, dataEncrypt } from '../app/utils/encryption-helper';
import { formatDateTimeInIST } from '../components/indiaDateFormate';
import { TransactionDetailsUI } from '../components/transaction-details-ui';

export const TransactionStock = () => {
    const routerParams = useParams();
    const navigate = useNavigate();
    const [transactionData, setTransactionData] = useState<any>([]);

    useEffect(() => {
        loadTransaction();
    }, []);

    const loadTransaction = async (): Promise<void> => {
        try {
            const res = await ApisService.getTransactionData('getById_v2', routerParams.id || '');
            const data: any = res.data.data;
            const transactionData = JSON.parse(dataDecrypt(data));
            if (transactionData[0].invoice_details) {
                for (let index = 0; index < transactionData[0].invoice_details.length; index++) {
                    const element = transactionData[0].invoice_details[index];
                    element.encrypted_id = dataEncrypt(`{"id":"${element.invoice_id}"}`);
                }
            }
            setTransactionData([...transactionData]);
        } catch (error) {
            console.error('Error in transaction:', error);
        }
    }

      const getPackingDetails = (data: any) => {
        navigate(`/stock/${data}`)
    }

    return <div>
        {/* <div className='d-flex justify-content-center  p-3 position-relative' style={{ backgroundColor: "#274472", color: "white" }}>
            <h4>Packing Details</h4>
            <img className='position-absolute end-0 top-0' src={LOGO} alt="" height={60} />
        </div> */}
        <div className='d-flex justify-content-between p-3 align-items-center' style={{ backgroundColor: "#274472", color: "white" }}>
            <Link to={`/order/${routerParams.id}`}><span ><PiArrowLeftBold size={22} className='text-white' /></span></Link>
            <span style={{ lineHeight: "0", textAlign: "center" }}><h4>Select Invoice</h4><div>{('currency_symbol' in (transactionData[0]?.buyer || {})) ? (
                  <>{transactionData[0]?.buyer?.name}</>
                ) : ('currency_symbol' in (transactionData[0]?.seller || {})) ? (
                  <>{transactionData[0]?.seller?.name}</>
                ) : (
                  <p></p>
                )}</div></span>
            <img src={LOGO} alt="" height={60} />
        </div>
        <br></br>
        {transactionData[0] && <div className="container-fluid">
            <div style={{ backgroundColor: "white", borderRadius: "3px" }}>
                {/* <Card className='box-shadow rounded-4 '>
                    <Card.Body className='p-2'>
                        <div className='row text-center'>
                            <div className='col-md-4 my-2 light-grey-right-border'>
                                <h6 className='mb-0'>Seller</h6>
                                <span>{transactionData[0]?.seller?.name}</span>
                            </div>
                            <div className='col-md-4 my-2 light-grey-right-border'>
                                <h6 className='mb-0'>Txn Date</h6>
                                <span>{formatDateTimeInIST(transactionData[0]?.created_date)}</span>
                            </div>
                            <div className='col-md-4 my-2'>
                                <h6 className='mb-0'>Txn Id</h6>
                                <span>{transactionData[0]?._id}</span>
                            </div>
                        </div>
                    </Card.Body>
                </Card> */}
                <TransactionDetailsUI data={[{header: 'Seller',value: transactionData[0]?.seller?.name},{header: 'Txn Date',value: formatDateTimeInIST(transactionData[0].created_date)},{header: 'Txn Id',value: transactionData[0]?._id}]} />
                <br></br>
                <div className='text-center primary-color'>{transactionData[0].invoice_details?.length>0?"Select an invoice number below to view detailed Stock Reconciliation information.":"invoice not generated"}</div>
                 {transactionData[0].invoice_details?.length > 0 && (
                        <div className="d-flex flex-wrap justify-content-center gap-2 mt-1">
                            {transactionData[0]?.invoice_details?.map((el: any, index: number) => (
                                <div
                                    key={index}
                                    className="border mb-2 rounded-4 box-shadow px-3 py-2 text-center"
                                    style={{ minWidth: "160px", cursor: "pointer" }}
                                    onClick={() => getPackingDetails(el.encrypted_id)}
                                >
                                    <div className="fw-bold text-primary">Invoice #{el.bill_no}</div>
                                    <small className="text-muted">Tap to view details</small>
                                </div>
                            ))}
                        </div>
                    )}
            </div>
        </div>}
        <br></br>
    </div>
}